import { useState } from 'react';
import { apiClient } from '../utils/apiClient';
import { formatFileSize } from '../utils/ticketFiles';
import './ReplyFiles.css';

// Files that came with (or went out with) a timeline entry. Downloads go
// through the API's ownership-checked route, so this only needs the refs the
// activity carries: [{ id, name, size }].
export default function ActivityFiles({ files }) {
  const [error, setError] = useState('');
  if (!Array.isArray(files) || files.length === 0) return null;

  const download = async (file) => {
    setError('');
    try {
      await apiClient.download(`/api/attachments/${file.id}/download`, file.name);
    } catch (err) {
      setError(`Could not download ${file.name}.`);
    }
  };

  return (
    <div className="activity-files">
      {files.map((file) => (
        <button key={file.id} type="button" className="activity-file" onClick={() => download(file)} title={`Download ${file.name}`}>
          <i className="fas fa-paperclip" aria-hidden="true"></i>
          <span className="activity-file-name">{file.name}</span>
          <span className="activity-file-size">{formatFileSize(file.size)}</span>
        </button>
      ))}
      {error && <p className="reply-files-error" role="alert">{error}</p>}
    </div>
  );
}
